import React from 'react';
import { withRouter, useLocation } from 'react-router-dom';

import { pathNamePages } from './shared/pathnames';
import AppDashboard from './AppDashboard';
import AppEncuestas from './AppEncuestas';

const App = () => {
  const { pathname } = useLocation();

  return pathname === pathNamePages.encuestas || pathname === pathNamePages.encuestasMail ? (
    <AppEncuestas />
  ) : (
    <AppDashboard />
  );
};

export default withRouter(App);
